import { render } from "./RestrictionProdModal.vue?vue&type=template&id=78028489&scoped=true"
import script from "./RestrictionProdModal.vue?vue&type=script&lang=js"
export * from "./RestrictionProdModal.vue?vue&type=script&lang=js"

import "./RestrictionProdModal.vue?vue&type=style&index=0&id=78028489&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78028489"]])

export default __exports__